import type { GetRoadmapsSortOrder } from './getRoadmapsSortOrder';
import type { GetRoadmapsListType } from './getRoadmapsListType';

export type GetRoadmapsParams = {
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
/**
 * 정렬 기준 (예 createdAt, title, courseCount, subscriptionCount)
 */
sortBy?: string;
/**
 * 정렬 순서 (ASC 오름차순, DESC 내림차순)
 */
sortOrder?: GetRoadmapsSortOrder;
/**
 * 특정 사용자의 로드맵 목록을 조회할 때 사용합니다. listType 파라미터와 함께 사용됩니다.
 */
userId?: number;
/**
 * 조회할 로드맵 목록의 유형입니다. userId 파라미터와 함께 사용될 수 있습니다.
 */
listType?: GetRoadmapsListType;
};
